import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "./Header";
import { CrownMark } from "./Logo";

const EASE = [0.85, 0, 0.15, 1];

export const CTASection = () => (
  <section
    data-testid="cta-section"
    className="relative overflow-hidden border-t border-gold/15 px-5 py-28 sm:px-8 sm:py-40"
  >
    <div
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-1/2 h-[60vmin] w-[80vmin] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(closest-side,rgba(217,22,4,0.14),transparent)] blur-3xl"
    />

    <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-center text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: EASE }}
      >
        <CrownMark className="h-14 w-[70px]" />
      </motion.div>

      <motion.h2
        data-testid="cta-heading"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, delay: 0.1, ease: EASE }}
        className="mt-8 font-serif text-4xl leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-7xl"
      >
        Prepare-se para
        <span className="gold-text block italic">o reinado</span>
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.2, ease: EASE }}
        className="mt-6 max-w-xl text-base leading-relaxed text-neutral-400 sm:text-lg"
      >
        Quer ser avisado antes de todo mundo ou garantir condições de pré-venda?
        Fale direto com a corte no WhatsApp.
      </motion.p>

      <motion.a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-cta-button"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.3, ease: EASE }}
        whileHover={{ scale: 1.04 }}
        whileTap={{ scale: 0.97 }}
        className="group relative mt-12 inline-flex items-center gap-4 overflow-hidden rounded-full bg-royal px-10 py-5 text-sm font-bold uppercase tracking-[0.25em] text-white shadow-[0_0_60px_-10px_rgba(217,22,4,0.7)] transition-shadow duration-500 hover:shadow-[0_0_90px_-5px_rgba(217,22,4,0.9)]"
      >
        <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/25 to-transparent transition-transform duration-700 group-hover:translate-x-0" />
        <MessageCircle className="relative z-10 h-5 w-5" />
        <span className="relative z-10">Falar no WhatsApp</span>
      </motion.a>

      <p data-testid="whatsapp-number" className="mt-6 text-xs uppercase tracking-[0.3em] text-neutral-500">
        (11) 95144-5379
      </p>
    </div>

    <footer data-testid="site-footer" className="relative z-10 mx-auto mt-24 max-w-7xl border-t border-white/10 pt-8">
      <div className="flex flex-col items-center justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-neutral-600 sm:flex-row">
        <span>© 2026 O Rei da 25</span>
        <span className="gold-text font-serif text-sm normal-case italic tracking-normal">
          oreida25.com.br
        </span>
        <span>São Paulo — Brasil</span>
      </div>
    </footer>
  </section>
);
